import { render, staticRenderFns } from "./FavoritesDrawer.vue?vue&type=template&id=95974cf4&scoped=true"
import script from "./FavoritesDrawer.vue?vue&type=script&lang=js"
export * from "./FavoritesDrawer.vue?vue&type=script&lang=js"
import style0 from "./FavoritesDrawer.vue?vue&type=style&index=0&id=95974cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95974cf4",
  null
  
)

export default component.exports